interface SynopsisContentProps {
  synopsis: string;
}

export function SynopsisContent({ synopsis }: SynopsisContentProps) {
  // Split synopsis into paragraphs
  const paragraphs = synopsis.split("\n").filter((p) => p.trim().length > 0);

  return (
    <div className="space-y-4">
      {paragraphs.map((paragraph, index) => (
        <p
          key={`synopsis-${paragraph.slice(0, 50)}`}
          className="text-[15px] leading-[24px] text-justify"
          style={{
            color: "#1E293B",
            fontFamily: 'Georgia, "Times New Roman", serif',
            textIndent: index === 0 ? 0 : "1.5em",
          }}
        >
          {paragraph}
        </p>
      ))}
    </div>
  );
}
